import { render, staticRenderFns } from "./PropertyStatusMessageHeader.vue?vue&type=template&id=448b2444&scoped=true&"
import script from "./PropertyStatusMessageHeader.vue?vue&type=script&lang=js&"
export * from "./PropertyStatusMessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PropertyStatusMessageHeader.vue?vue&type=style&index=0&id=448b2444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b2444",
  null
  
)

export default component.exports